import { Flex, Typography } from 'antd';
import { renderDate, renderInfoValue } from 'utils/helpers';

interface CurrentSeasonProps {
  seasonIndex: string;
  from: string;
  to: string;
}

const DATE_FORMAT = 'MMMM DD, YYYY';

const CurrentSeason = ({ seasonIndex, from, to }: CurrentSeasonProps) => {
  if (!from && !to)
    return (
      <Typography.Text
        type="secondary"
        className="season-overview__widget-text--subtitle"
      >
        No data available
      </Typography.Text>
    );

  return (
    <Flex vertical gap={2}>
      <Typography.Title
        className="season-overview__widget-text--title"
        level={5}
      >
        {renderInfoValue(seasonIndex)}
      </Typography.Title>
      <Typography.Text
        type="secondary"
        className="season-overview__widget-text--subtitle"
      >
        {renderDate(from, '-', DATE_FORMAT)} to{' '}
        {renderDate(to, '-', DATE_FORMAT)}
      </Typography.Text>
    </Flex>
  );
};

export default CurrentSeason;
